'use client';
import React from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import styled from '@benzinga/themetron';
import { Icon } from '@benzinga/core-ui';

interface PopupProps {
  children: React.ReactNode;
  onClose: () => void;
}

export const CloseContainer: React.FC<PopupProps> = ({ children, onClose }) => {
  return (
    <CloseContainerWrapper className="close-container">
      <div className="close-btn" onClick={onClose}>
        <Icon icon={faTimes} />
      </div>
      {children}
    </CloseContainerWrapper>
  );
};

const CloseContainerWrapper = styled.div`
  &.close-container {
    position: relative;
    border-radius: ${({ theme }) => theme.borderRadius.md};
    box-shadow:
      0 0 transparent,
      0 0 transparent,
      0 0 6px 1px rgb(163 163 163 / 20%);

    .close-btn {
      align-items: center;
      background-color: white;
      border-radius: 14px;
      border: solid 1px ${({ theme }) => theme.colors.border};
      box-shadow:
        0 0 transparent,
        0 0 transparent,
        0 0 6px 1px rgb(163 163 163 / 20%);
      color: ${({ theme }) => theme.colorPalette.gray700};
      cursor: pointer;
      display: flex;
      height: 28px;
      padding: 0px 5px;
      position: absolute;
      right: -12px;
      text-align: center;
      /* top: 6px; */
      top: -14px;
      width: 28px;
    }

    .call-to-action-container {
      border: none;
      &:hover {
        box-shadow: unset;
      }
    }
  }
`;
